import styled from 'styled-components'
import { giphyWhite } from '@giphy/js-brand'
import { Button } from '@giphy/react-giphy-brand'

export const Container = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    background: rgb(33, 33, 33);
    border-radius: 10px;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.5);
    height: 540px;
    width: 800px;
    padding-top: 40px;
    align-items: center;
    z-index: 2;
`

export const SmallTitle = styled.h4`
    font-size: 15px;
    font-weight: bold;
    color: rgb(166, 166, 166);
    line-height: 12px;
    letter-spacing: 4px;
    margin-right: -5px;
`

export const TitleGif = styled.img`
    height: 110px;
    margin-top: 29px;
`

export const Description = styled.p`
    font-size: 24px;
    font-weight: bold;
    margin-top: 24px;
    margin-bottom: 39px;
    color: ${giphyWhite};
    text-align: center;
    width: 666px;
    line-height: 32px;
`

export const UploadButton = styled(Button)`
    border-radius: 2px;
    height: 42px;
    width: 448px;
    background: linear-gradient(45deg, rgb(153, 51, 255) 0%, rgb(97, 87, 255) 100%);
    font-size: 17px;
`

export const MoreInfo = styled.a`
    color: rgb(166, 166, 166);
    font-size: 17px;
    font-weight: bold;
    height: 20px;
    margin-top: 15px;
    text-align: center;
    text-decoration: underline;
    width: 125px;
    cursor: pointer;
`

export const BottomGif = styled.img`
    width: 700px;
    margin-top: 10px;
}`

export const Overlay = styled.div`
    background: rgba(0, 0, 0, 0);
    cursor: pointer;
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 1;
`
